import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const Separator = _props => {
  return /*#__PURE__*/_jsx("div", {
    style: {
      margin: '20px 40px 20px 40px',
      borderTop: 'solid 1px #e0e0e0'
    }
  });
};